<!--LOADING-->
<ng-template [ngIf]="isLoading">
  <app-loading-page class="white-top-theme"></app-loading-page>
</ng-template>
<!--END LOADING-->
<!--AGENT PLATFORM DETAIL-->
<ng-template [ngIf]="!isLoading">
  <ng-container *ngIf="contentData">
    <section>
      <div class="wrapper">
        <!--CMS CONTENT-->
        <!--LEFT SIDE CONTENT-->
        <!--NOTE ngIf used to populate WordPress content-->
        <app-static-page [bodyContent]="contentData?.content | safe : 'html'"></app-static-page>

        <!--START CAROUSEL-->
        <app-banner-carousel
          [carouselDotActiveCSS]="'default-active'"
          [carouselSectionCSS]="['card-carousel', 'image-carousel']"
          [carouselLeftArrowCSS]="['leftRs', 'arrow-left', 'left-arrow']"
          [carouselRightArrowCSS]="['rightRs', 'arrow-right', 'right-arrow']"
          [carouselItems]="images"
          [bannerPositionsCss]="[
            'background-position-center-x',
            'background-position-top-y',
            'background-repeat'
          ]">
        </app-banner-carousel>
        <!--END CAROUSEL-->
      </div>
    </section>
  </ng-container>
</ng-template>
<!--END AGENT PLATFORM DETAIL-->
